<template>
  <div class="layout-inner dashbaord cal_events">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">
        <div class="container-fluid flex-grow-1 pg_content_container">

          <div class="row sub_hd_bar">
            <div class="col-12">

              <div class="sub_hd_ic">
                <span>
                  <span class="ic ic11-dateRange"></span>
                </span>
              </div>

              <div class="srh_bx">
                <input type="text" class="search-input" placeholder="search by calendar event title" aria-label="search by calendar event name" v-model="searchTerm">
                <b-btn class="btn btn_clear btn-secondary" @click="searchTerm = ''" v-if="searchTerm.length > 0">
                  <span class="ic-close"></span>
                </b-btn>
              </div>

              <div class="list_info">
                <span>Calendar Events</span>
              </div>

            </div>
          </div>


            <template v-if="isCalendarEventsLoaded">
              <template v-if="calendarEvents.length > 0">
                <template v-if="filteredCalendarEvents.length > 0">
                  <div class="row lst_pg__row" v-for="calEvent in filteredCalendarEvents"  @mouseover="mouseOver(calEvent)" @mouseleave="mouseLeave(calEvent)">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col_date">
                          <div>{{calEvent.formattedStartDateTime}}</div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col_title">
                          <div>{{calEvent.title}}</div>
                          <div class="members"><small>{{calEvent.who}}</small></div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col_location">
                          <div class="row">
                            <div class="col-1 ic ic9-location2"></div>
                            <div class="col-11 location_txt">{{calEvent.location}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="mt-5 text-center">
                    <h4>No results found!</h4>
                  </div>
                </template>
              </template>
              <template v-else>
                <div class="mt-5 text-center">
                  <h4>You don't have any calendar event.</h4>
                </div>
              </template>
            </template>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Navbar from '../../misc/components/./Navbar'
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'

  export default {
    name: 'calendar-event-list',
    props: ['userUuid'],
    components: {
      Navbar
    },
    data: () => {
      return {
        searchTerm: '',
        calendarEvents: [],
        isCalendarEventsLoaded: false,
        minDatetime: DateTime.utc().toISO()
      }
    },
    computed: {
      ...mapState({
        'userObj': state => state.user.userObj
      }),
      filteredCalendarEvents () {
        return this.calendarEvents.filter(item => {
          return item.title.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
      }
    },
    async mounted () {
      await this.loadCalendarEevents()
    },
    methods: {
      ...mapActions([
        'loadAllCalendarEvents'
      ]),
      showLoader () {
        if (this.$root.$refs.loadingModal) {
          this.$root.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$root.$refs.loadingModal) {
          this.$root.$refs.loadingModal.hide()
        }
      },
      async loadCalendarEevents () {
        this.calendarEvents = []
        let calEvents = await this.loadAllCalendarEvents()
        this.populateCalendarEvents(calEvents)
      },
      populateCalendarEvents (calEvents) {
        calEvents.forEach(calEvent => {
          let users = []
          _.forEach(calEvent.participantDetails, (p) => {
            users.push(p.firstName + ' ' + p.lastName)
          })
          let who = users.join(', ').replace(/,(?=[^,]*$)/, ' and')
          calEvent.who = who
          calEvent.active = false
          this.calendarEvents.push(calEvent)
        })
        this.isCalendarEventsLoaded = true
      },
      mouseOver(calEvent) {
        calEvent.active = true
      },
      mouseLeave(calEvent) {
        calEvent.active = false
      },
      formatDate (selected) {
        return DateTime.fromISO(selected, {zone: 'America/New_York'}).toFormat('ccc LLL dd, yyyy h:mm a (ZZZZ)')
      }
    }
  }
</script>

<style>
  .cal_events .page-heading .search_field {
    position: relative;
    margin-top: 21px;
  }

  .cal_events .page-heading .search_field .btn_clear {
    position: absolute;
    right: 18px;
    top: -3px;
    outline: none;
  }
  sup {
    color: #ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/CalendarEventList.vue